import { React } from 'react';
import { Button } from 'antd-mobile';
import liff from '@line/liff';

const IndividualSuccess = () => {
  const closeLiff = () => {
    liff.closeWindow();
  };
  return (
    <div className="main-container">
      <div className="form-container">
        <div className="text-align-center">
          <img
            className="pd-6"
            src="/images/illustration/individual-success.svg"
            alt="Description"
          />
          <div className="pd-6">
            <div className="heading font-bold pd-1"> 綁定成功</div>
            <div className="text-body font-normal">
              您已成功綁定和運租車LINE會員
            </div>
          </div>
        </div>
        <Button block className="line-button" onClick={closeLiff}>
          回 LINE 官方帳號
        </Button>
      </div>
    </div>
  );
};

export default IndividualSuccess;
